/* contact-form-rich.js
 * - Custom validation for required radio pillsets (the radios are visually
 *   hidden for the pill UI, so the browser's native validation tooltip would
 *   render against a 0×0 element and be invisible).
 * - Visual loading state on the submit button.
 */
(function () {
  if (window.__cfrInited) return;
  window.__cfrInited = true;

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('cfr__form')) return;

      var invalidPillset = findInvalidRequiredPillset(form);
      if (invalidPillset) {
        e.preventDefault();
        showPillsetError(invalidPillset);
        invalidPillset.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var btn = form.querySelector('.cfr__submit');
      if (btn) {
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
      }
    },
    false
  );

  function findInvalidRequiredPillset(form) {
    var pillsets = form.querySelectorAll('.cfr__pillset[data-required="true"]');
    for (var i = 0; i < pillsets.length; i++) {
      var fs = pillsets[i];
      if (!fs.querySelector('input[type="radio"]:checked')) return fs;
    }
    return null;
  }

  function showPillsetError(fieldset) {
    fieldset.classList.add('cfr__pillset--invalid');
    if (!fieldset.querySelector('.cfr__pillset-error')) {
      var msg = document.createElement('p');
      msg.className = 'cfr__pillset-error';
      msg.textContent = 'נא לבחור אחת מהאפשרויות';
      fieldset.appendChild(msg);
    }
    var radios = fieldset.querySelectorAll('input[type="radio"]');
    Array.prototype.forEach.call(radios, function (r) {
      r.addEventListener('change', function clear() {
        fieldset.classList.remove('cfr__pillset--invalid');
        var err = fieldset.querySelector('.cfr__pillset-error');
        if (err && err.parentNode) err.parentNode.removeChild(err);
      });
    });
  }
})();
